const Card = {
  baseStyle: {
    p: '22px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    borderRadius: '20px',
    position: 'relative',
    wordWrap: 'break-word',
    backgroundClip: 'border-box',
    borderWidth: '1px',
    // Default elevation: "raised" — clear but not heavy
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.04)',
    // will-change: transform prevents repaint jank during lift animation
    willChange: 'transform',
    transition: 'box-shadow 0.20s cubic-bezier(0.4, 0, 0.2, 1), transform 0.20s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.20s ease',
    _hover: {
      transform: 'translateY(-2px)',
      boxShadow: '0px 12px 28px rgba(0, 0, 0, 0.10), 0px 3px 8px rgba(0, 0, 0, 0.06)',
    },
  },
  variants: {
    panel: props => ({
      // Warm cream gradient: matches surface.raised palette
      bg: props.colorMode === 'dark'
        ? '#111C44'
        : 'linear-gradient(to bottom, #ffffff 0%, rgba(250,250,247,0.70) 100%)',
      borderColor: props.colorMode === 'dark' ? 'whiteAlpha.100' : 'gray.100',
      _hover: {
        // Indigo border tint on hover — brand.200 = #C7D2FE
        borderColor: props.colorMode === 'dark' ? 'whiteAlpha.200' : 'rgba(199,210,254,0.70)',
        boxShadow: '0px 12px 28px rgba(0, 0, 0, 0.09), 0px 3px 8px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px rgba(99,102,241,0.10)',
      },
    }),
    // Subtle: sits flush in a section, minimal shadow
    subtle: props => ({
      bg: props.colorMode === 'dark' ? '#111C44' : 'gray.50',
      borderColor: props.colorMode === 'dark' ? 'whiteAlpha.100' : 'gray.200',
      boxShadow: 'none',
      _hover: {
        transform: 'translateY(-1px)',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.07)',
        borderColor: props.colorMode === 'dark' ? 'whiteAlpha.200' : 'gray.300',
      },
    }),
    // Floating: modal-like, high elevation
    floating: props => ({
      bg: props.colorMode === 'dark' ? '#111C44' : 'white',
      borderColor: props.colorMode === 'dark' ? 'whiteAlpha.200' : 'gray.200',
      boxShadow: '0px 20px 40px rgba(0, 0, 0, 0.12), 0px 4px 12px rgba(0, 0, 0, 0.08)',
      _hover: {
        transform: 'translateY(-3px)',
        boxShadow: '0px 28px 56px rgba(0, 0, 0, 0.16), 0px 8px 18px rgba(0, 0, 0, 0.10)',
      },
    }),
    // Stat: KPI card — indigo accent stripe at top, no hover lift (stable read)
    stat: props => ({
      bg: props.colorMode === 'dark' ? '#111C44' : 'white',
      borderColor: props.colorMode === 'dark' ? 'whiteAlpha.100' : 'gray.100',
      // 3px indigo stripe at top: brand.500 = #6366F1
      backgroundImage: props.colorMode === 'dark'
        ? 'linear-gradient(to bottom, rgba(99,102,241,0.40) 0px, rgba(99,102,241,0.40) 3px, #111C44 3px)'
        : 'linear-gradient(to bottom, rgba(99,102,241,0.75) 0px, rgba(99,102,241,0.75) 3px, #ffffff 3px)',
      borderRadius: '20px',
      overflow: 'hidden',
      willChange: 'transform',
      _hover: {
        transform: 'translateY(-2px)',
        boxShadow: '0px 10px 24px rgba(99,102,241,0.15), 0px 2px 6px rgba(0,0,0,0.06)',
        borderColor: props.colorMode === 'dark' ? 'brand.700' : 'brand.200',
      },
    }),
  },
  defaultProps: {
    variant: 'panel',
  },
};

// CardHeader: visual separation from body via padding + optional border-bottom
const CardHeader = {
  baseStyle: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    pb: '12px',
    mb: '12px',
    borderBottomWidth: '1px',
  },
  variants: {
    panel: props => ({
      borderBottomColor: props.colorMode === 'dark' ? 'whiteAlpha.100' : 'gray.100',
    }),
    subtle: props => ({
      borderBottomColor: props.colorMode === 'dark' ? 'whiteAlpha.100' : 'gray.200',
    }),
    floating: props => ({
      borderBottomColor: props.colorMode === 'dark' ? 'whiteAlpha.200' : 'gray.200',
    }),
  },
  defaultProps: {
    variant: 'panel',
  },
};

const CardBody = {
  baseStyle: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  },
};

export const CardComponent = {
  components: {
    Card,
    CardHeader,
    CardBody,
  },
};
